import mixpanel from 'mixpanel-browser'

import type { Persistence, Mixpanel } from 'mixpanel-browser'
import { MixpanelEventMethod } from '../Mixpanel.types'
import type { MixpanelEventData, MixpanelSDKConfiguration } from '../Mixpanel.types'

export default class MixpanelWebSDK {
	private mixpanel: Mixpanel = mixpanel

	constructor(mixpanelSdkConfiguration: MixpanelSDKConfiguration) {
		if (!mixpanelSdkConfiguration?.token) {
			throw new Error('Mixpanel token is required')
		}

		this.mixpanel = mixpanel

		// @ts-ignore
		this.mixpanel.init(mixpanelSdkConfiguration.token, {
			debug: mixpanelSdkConfiguration.debug || false,
			persistence: (mixpanelSdkConfiguration.persistence || 'localStorage') as Persistence,
			track_pageview: mixpanelSdkConfiguration.track_pageview,
		})
	}

	public identifyUser(userId: string): void {
		this.mixpanel.identify(userId)
	}

	public resetUser(): void {
		this.mixpanel.reset()
	}

	public sendEvent(eventData: MixpanelEventData): void {
		switch (eventData.method) {
			case MixpanelEventMethod.SET_SUPER_PROPERTIES: {
				const [properties] = eventData.arguments

				this.mixpanel.register(properties as Record<string, unknown>)
				break
			}
			case MixpanelEventMethod.SET_USER_PROPERTIES: {
				const [properties] = eventData.arguments

				this.mixpanel.people.set(properties as Record<string, unknown>)
				break
			}
			default: {
				this.mixpanel.track(eventData.eventName, eventData.arguments[0] as Record<string, unknown>)
			}
		}
	}
}
